import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { ImportContainerComponent } from './import-container/import-container.component';
const log = new LoggingService();

export const ImportRoute: Ng2StateDeclaration = {
    // name: 'Import.**'
    name: 'importgovconpay',
    url: '/import',
    // , loadChildren: () => import('./import.module').then(r => r.ImportModule)
    data: { requiresAuth: true },

    component: ImportContainerComponent
};
